import { getDistinctFilteredForms } from "js/formatting/getDistinctFilteredForms";
import { useState, useEffect } from "react";
import config from "config/config";
import { useRowPagination } from "hooks/useRowPagination";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { states } from "js/placeholderData/states";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import { getAgentFormsByDocument } from "service/forms/getAgentFormsByDocument";
import RowPagination from "components/General/RowPagination";
import AutoCompleteComboBox from "components/General/AutoCompleteComboBox";
import InputWithActionButton from "components/General/InputWithActionButton";
import PillWithActionButton from "components/General/PillWithActionButton";
import SimpleDataRow from "components/General/SimpleDataRow";

import { useForm, Controller } from "react-hook-form";
import { isFlagEnabled, isCSR, isCSRAdmin } from "js/utilities";
import FormInputError from "components/General/FormInputError";
import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { sendEmailNotification_v2 } from "service/notificationservice/sendEmailNotification";

export default function SearchByDocumentPanel({
  selectedCompany,
  setSelectedCompany,
  selectedState,
  setSelectedState,
  selectedCatagory,
  setSelectedCatagory,
  selectedProduct,
  setSelectedProduct,
  searchByKeyWords,
  setSearchByKeyWords,
  isClearClicked,
}) {
  const {
    handleSubmit,
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();

  const { t } = useTranslation();
  const { csrUser } = useSelector((state) => state.csrUser);

  const [companyFilterOptions, setCompanyFilterOptions] = useState([
    { value: "all", displayAs: "Select Company" },
  ]);
  const [stateFilterOptions, setStateFilterOptions] = useState([
    { value: "all", displayAs: "Select State" },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [catagories, setCatagories] = useState([]);
  const [products, setProducts] = useState([
    { value: "life", displayAs: "Life" },
    { value: "annuity", displayAs: "Annuity" },
  ]);
  const [contractTypes] = useState([
    { value: "both", displayAs: "Both" },
    { value: "fixed", displayAs: "Fixed" },
    { value: "variable", displayAs: "Variable" },
  ]);
  const [selectedContractType, setSelectedContractType] = useState("both");
  const [productLine, setProductLine] = useState("");
  const [allSelectedByDocumentForms, setAllSelectedByDocumentForms] = useState(
    []
  );
  const [searchbyDocumentForms, setSearchbyDocumentForms] = useState([]);
  const [isSendEmailDialogOpen, setIsSendEmailDialogOpen] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState("");
  const [sendEmailError, setSendEmailError] = useState("");
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [sendEmailSuccessMessage, setSendEmailSuccessMessage] = useState("");
  const [selectedFormId, setSelectedFormId] = useState(null);
  const isCSRUser = isCSR(csrUser) || isCSRAdmin(csrUser);
  const setCompanyOptions = (company) => {
    return {
      value: company?.name,
      displayAs: `${company?.abbreviation}`,
    };
  };

  const enableProductType = isFlagEnabled(
    "ENABLE_SEARCH_BY_DOCUMENT_PRODUCT_TYPE"
  );

  const getCompanyState = () => {
    const companySelectionArray = Object.entries(
      JSON.parse(config.COMPANY_BLOCK_CODES)
    ).map(([name, abbreviation]) => ({ name, abbreviation }));

    const filteredCompanies = companySelectionArray?.map((company) =>
      setCompanyOptions(company)
    );
    setCompanyFilterOptions((current) => current.concat(filteredCompanies));

    const filteredStates = states?.map((company) => setCompanyOptions(company));
    setStateFilterOptions((current) => current.concat(filteredStates));
  };

  const getDistinctCategory = (array) => {
    let catagoryList = [];
    array.forEach((form) => {
      if (catagoryList?.length === 0) {
        catagoryList.push(form);
      } else {
        let exstingForms = catagoryList.find(
          (c) => c.categoryId === form.categoryId
        );
        if (!exstingForms) {
          catagoryList.push(form);
        }
      }
    });
    return catagoryList;
  };

  const addKeyWord = (searchKeyword) => {
    let keyWord = searchKeyword?.trim();
    if (keyWord) {
      if (!searchByKeyWords.includes(keyWord))
        setSearchByKeyWords((current) => [...current, keyWord]);
    }
  };

  const removeSearchKeyWord = (search, value) => {
    const index = search.indexOf(value);
    if (index > -1) {
      search.splice(index, 1);
    }
    return search;
  };

  const removeKeyWord = (search) => {
    let value = removeSearchKeyWord(searchByKeyWords, search);
    if (value?.length > 0) setSearchByKeyWords((curr) => [...curr]);
    else setSearchByKeyWords([]);
    reset();
    document.getElementById("Site Search").value = "";
  };

  const filterByKeyWords = (form, keywords) => {
    let formFound;
    keywords.forEach((keyWord) => {
      let splitKeyWords = keyWord.split(/\s+/g);
      splitKeyWords.forEach((sk) => {
        if (form.keywords.toLowerCase().includes(sk.toLowerCase()))
          formFound = form;
      });
    });
    return formFound;
  };

  const filteredForms = (forms, categoryId, product, keywords) => {
    if (
      selectedCompany !== "all" &&
      selectedCompany.value !== "all" &&
      selectedCompany !== "all" &&
      selectedCompany.value !== "all" &&
      forms?.length > 0
    ) {
      let filteredSelectedByDocumentForms = [...forms];

      if (filteredSelectedByDocumentForms?.length > 0) {
        if (categoryId && categoryId !== "all") {
          filteredSelectedByDocumentForms =
            filteredSelectedByDocumentForms.filter(
              (form) => parseInt(form.categoryId) === parseInt(categoryId)
            );
        }
        if (product && product !== "all") {
          filteredSelectedByDocumentForms =
            filteredSelectedByDocumentForms.filter(
              (form) => form?.productType?.toLowerCase() === selectedProduct
            );
        }
        if (selectedContractType) {
          if (selectedContractType === "both") {
            filteredSelectedByDocumentForms =
              filteredSelectedByDocumentForms.filter(
                (form) =>
                  (form.contractType &&
                    form.contractType.toLowerCase() === "both") ||
                  form.contractType == null
              );
          } else if (selectedContractType !== "all") {
            filteredSelectedByDocumentForms =
              filteredSelectedByDocumentForms.filter(
                (form) =>
                  form.contractType &&
                  form.contractType.toLowerCase() ===
                    selectedContractType.toLowerCase()
              );
          }
        }
        if (
          keywords?.length > 0 &&
          filteredSelectedByDocumentForms?.length > 0
        ) {
          filteredSelectedByDocumentForms =
            filteredSelectedByDocumentForms.filter((form) => {
              let formFound = filterByKeyWords(form, keywords);
              if (formFound) return formFound;
            });
        }
      }
      setSearchbyDocumentForms(
        getDistinctFilteredForms(filteredSelectedByDocumentForms)
      );
    }
  };

  // GetForm API call
  async function getForm(company, state) {
    if (company && state !== "all") {
      setIsLoading(true);
      await getAgentFormsByDocument(company, state)
        .then((response) => {
          const { form } = response;
          if (form?.length > 0) {
            setSearchbyDocumentForms(form);
            setAllSelectedByDocumentForms(form);
            setCatagories(getDistinctCategory(form));
            filteredForms(
              form,
              selectedCatagory,
              selectedProduct,
              searchByKeyWords
            );
            setProductLine(form?.map((f) => f.productType)[0]);
          } else {
            setSearchbyDocumentForms([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log("Error", error);
        });
    } else {
      setSearchbyDocumentForms([]);
    }
  }

  const onSubmit = async (data, e) => {
    addKeyWord(data.keyword);
    e.target.reset();
  };

  useEffect(() => {
    setSearchbyDocumentForms([]);
  }, [isClearClicked]);

  useEffect(() => {
    filteredForms(
      allSelectedByDocumentForms,
      selectedCatagory,
      selectedProduct,
      searchByKeyWords
    );
    clearErrors();
  }, [
    selectedCatagory,
    selectedProduct,
    searchByKeyWords,
    selectedContractType,
  ]);

  useEffect(() => {
    if (selectedCompany !== "all" && selectedState !== "all") {
      setSelectedCatagory("all");
      setSelectedProduct("all");
      setSearchByKeyWords([]);
      getForm(selectedCompany?.value, selectedState?.displayAs);
      setSelectedCatagory(selectedCatagory);
      setSelectedProduct(selectedProduct);
      setSearchByKeyWords(searchByKeyWords);
    }
    clearErrors();
  }, [selectedCompany, selectedState]);

  useEffect(() => {
    getCompanyState();
  }, []);

  const {
    rowsForDisplay: searchbyDocumentFormsRows,
    rowPaginationProps: searchbyDocumentFormsPaginationProps,
  } = useRowPagination(searchbyDocumentForms);

  return (
    <>
      <EverlakeLoadingOverlay
        isLoading={isLoading}
        loadingText={t("AgentSearchByDocumentForms-loadingText")}
      >
        <div className="p-2 md:p-4 bg-white rounded-b-lg shadow-[2px_4px_4px_0_rgba(0,0,0,0.16)]">
          <div
            className={`grid gap-2 md:gap-x-4 ${
              enableProductType
                ? "md:grid-cols-[1fr,0.5fr,0.5fr,0.5fr,0.8fr,1fr]"
                : "md:grid-cols-[1fr,0.5fr,0.8fr,1fr]"
            } `}
          >
            <AutoCompleteComboBox
              labelName={t("AgentSearchByDocumentForms-label-1")}
              inputPlaceholderText={t(
                "AgentSearchByDocumentForms-placeholder-1"
              )}
              options={companyFilterOptions}
              invalidMessage={t(
                "AgentSearchByDocumentForms-company-field-errorMessage"
              )}
              selectedOption={selectedCompany}
              setSelectedOption={setSelectedCompany}
            />
            <AutoCompleteComboBox
              labelName={t("AgentSearchByDocumentForms-label-2")}
              inputPlaceholderText={t(
                "AgentSearchByDocumentForms-placeholder-2"
              )}
              options={stateFilterOptions}
              invalidMessage={t(
                "AgentSearchByDocumentForms-state-field-errorMessage"
              )}
              selectedOption={selectedState}
              setSelectedOption={setSelectedState}
            />

            {!isLoading &&
              selectedCompany !== "all" &&
              selectedCompany.value !== "all" &&
              selectedState !== "all" &&
              selectedState.value !== "all" &&
              catagories?.length > 0 &&
              products?.length > 0 && (
                <>
                  {enableProductType && (
                    <>
                      <div className="relative mt-1">
                        <div className="flex items-center mb-1">
                          <label id="formsDocumentProduct">
                            {t("AgentSearchByDocumentForms-label-4")}
                          </label>
                        </div>
                        <div className="relative">
                          <select
                            id="productId"
                            className="w-full"
                            defaultValue={selectedProduct}
                            onChange={(e) => {
                              setSelectedProduct(e.target.value);
                            }}
                          >
                            <option value="all">All</option>
                            {products?.length > 0 && (
                              <>
                                {products.map((p) => (
                                  <option
                                    key={`forms - ${p.value}`}
                                    value={p.value}
                                  >
                                    {p.displayAs}
                                  </option>
                                ))}
                              </>
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="relative mt-1">
                        <div className="flex items-center mb-1">
                          <label id="formsDocumentContractType">
                            {t("AgentSearchByDocumentForms-label-5")}
                          </label>
                        </div>
                        <div className="relative">
                          <select
                            id="contractTypeId"
                            className="w-full"
                            value={selectedContractType}
                            onChange={(e) => {
                              setSelectedContractType(e.target.value);
                            }}
                          >
                            {contractTypes.map((ct) => (
                              <option
                                key={`contract-type - ${ct.value}`}
                                value={ct.value}
                              >
                                {ct.displayAs}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="relative mt-1">
                    <div className="flex items-center mb-1">
                      <label id="formsDocumentCategory">
                        {t("AgentSearchByDocumentForms-label-3")}
                      </label>
                    </div>
                    <div className="relative">
                      <select
                        id="categoryId"
                        className="w-full"
                        defaultValue={selectedCatagory}
                        onChange={(e) => {
                          setSelectedCatagory(e.target.value);
                        }}
                      >
                        <option value="all">All</option>
                        {catagories?.length > 0 && (
                          <>
                            {catagories.map((c) => (
                              <option
                                key={`forms - ${c.categoryId}`}
                                value={c.categoryId}
                              >
                                {c.category}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                  </div>

                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col-reverse"
                  >
                    <Controller
                      name="keyword"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <InputWithActionButton
                          labelName="Keyword"
                          buttonType="submit"
                          buttonLabel={t(
                            "AgentSearchByDocumentForms-search-button"
                          )}
                          ariaLabel={t(
                            "AgentSearchByDocumentForms-search-aria-label"
                          )}
                          placeholder={t(
                            "AgentSearchByDocumentForms-search-placeholder"
                          )}
                          onChange={onChange}
                        />
                      )}
                      rules={{
                        pattern: {
                          value: /^[A-Za-z0-9() \-]+$/,
                          message:
                            "Keyword cannot contain any special characters (@,*,&, etc.).",
                        },
                        required: "Please enter keyword to search",
                      }}
                    />
                  </form>

                  {errors?.keyword?.message && (
                    <>
                      <div></div>
                      <div></div>
                      <div></div>
                      <FormInputError errorMessage={errors?.keyword?.message} />
                    </>
                  )}
                  {!enableProductType && (
                    <div className="mt-2 flex flex-start gap-4">
                      <h3 className="text-sm">
                        {t("AgentSearchByDocumentForms-productLine")}{" "}
                        <span className="font-semibold">{productLine}</span>
                      </h3>
                    </div>
                  )}
                </>
              )}
          </div>
          {searchByKeyWords &&
            !isLoading &&
            selectedCompany !== "all" &&
            selectedCompany.value !== "all" &&
            selectedState !== "all" &&
            selectedState.value !== "all" && (
              <div className="mt-2 flex flex-start gap-2 ">
                {searchByKeyWords.map((search, idx) => (
                  <PillWithActionButton
                    key={`search for forms - ${idx}`}
                    label={search}
                    action={() => removeKeyWord(search)}
                  />
                ))}
              </div>
            )}
        </div>
        {searchbyDocumentFormsRows?.length > 0 ? (
          <>
            <p className="mt-4 mb-2">
              <Trans
                i18nKey="AgentSearchByDocumentForms-disclaimer"
                components={{
                  span1: <span className="font-semibold"></span>,
                }}
              ></Trans>
            </p>
            {searchbyDocumentFormsRows?.map((form, idx) => (
              <SimpleDataRow
                key={`forms - ${idx}`}
                data={form}
                type="form"
                formSearchType={"Document Search"}
                hideFormSubTitle={true}
                isCSRUser={isCSRUser}
                onSendEmailClick={(row) => {
                  setRecipientEmail("");
                  setSendEmailSuccessMessage("");
                  setSendEmailError("");
                  setSelectedFormId(Number(row?.id));
                  setIsSendEmailDialogOpen(true);
                }}
              />
            ))}
            <RowPagination {...searchbyDocumentFormsPaginationProps} />
          </>
        ) : (
          <div className="w-full mt-4 mb-2 md:ml-6 text-center">
            {!isLoading && (
              <>
                {!selectedCompany ||
                selectedCompany === "all" ||
                selectedCompany?.value === "all" ||
                !selectedState ||
                selectedState === "all" ||
                selectedState?.value === "all" ? (
                  <h3>{t("AgentSearchByDocumentForms-displayMessage")}</h3>
                ) : (
                  <h3>{t("AgentForms-displayMessage")}</h3>
                )}
              </>
            )}
          </div>
        )}
      </EverlakeLoadingOverlay>
      <Dialog
        open={isCSRUser && isSendEmailDialogOpen}
        onClose={() => {
          setIsSendEmailDialogOpen(false);
          setRecipientEmail("");
          setSendEmailError("");
          setSendEmailSuccessMessage("");
          setSelectedFormId(null);
        }}
        className="ui-dialogs"
      >
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog max-w-md w-full"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              Send Email
            </Dialog.Title>
            <button
              className="ui-default-dialog-close"
              aria-label="close send email dialog"
              onClick={() => {
                setIsSendEmailDialogOpen(false);
                setRecipientEmail("");
                setSendEmailError("");
                setSendEmailSuccessMessage("");
                setSelectedFormId(null);
              }}
            >
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
            <hr />
            <div className="ui-dialog-body">
              <label
                id="send_email_input_label"
                htmlFor="send_email_input"
                className="block mb-2"
              >
                Recipient Email Address
              </label>
              <input
                id="send_email_input"
                type="email"
                aria-labelledby="send_email_input_label"
                className="mt-1"
                value={recipientEmail}
                onChange={(e) => {
                  setRecipientEmail(e.target.value);
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");
                }}
                disabled={isSendingEmail}
              />
              {sendEmailError ? (
                <FormInputError errorMessage={sendEmailError} />
              ) : null}
              {sendEmailSuccessMessage ? (
                <p className="mt-2 text-green-700">{sendEmailSuccessMessage}</p>
              ) : null}
            </div>
            <div className="block text-right mt-6">
              <button
                type="button"
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => {
                  setIsSendEmailDialogOpen(false);
                  setRecipientEmail("");
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");
                  setSelectedFormId(null);
                }}
                disabled={isSendingEmail}
              >
                Cancel
              </button>
              <button
                type="button"
                className="ui-btn-primary ui-btn-min-w mt-4 ml-2"
                onClick={async () => {
                  const trimmedEmail = recipientEmail.trim();
                  const emailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

                  if (!trimmedEmail) {
                    setSendEmailError("Email is required.");
                    return;
                  }

                  if (!emailPattern.test(trimmedEmail)) {
                    setSendEmailError("Please enter a valid email address.");
                    return;
                  }

                  setIsSendingEmail(true);
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");

                  try {
                    await sendEmailNotification_v2(
                      trimmedEmail,
                      selectedFormId
                    );
                    setSendEmailSuccessMessage("Email sent successfully.");
                    setRecipientEmail("");
                  } catch (error) {
                    setSendEmailError("Failed to send email.");
                  } finally {
                    setIsSendingEmail(false);
                  }
                }}
                disabled={isSendingEmail}
              >
                {isSendingEmail ? "Sending..." : "Send"}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
